import { render, staticRenderFns } from "./clientBox.vue?vue&type=template&id=2ce15568&scoped=true&"
import script from "./clientBox.vue?vue&type=script&lang=js&"
export * from "./clientBox.vue?vue&type=script&lang=js&"
import style0 from "./clientBox.vue?vue&type=style&index=0&id=2ce15568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce15568",
  null
  
)

export default component.exports